import React from "react";
import AephoriaTable from '../comps/aephoriaTable';
import * as aserver from '../../APIClient';
import AlertModal from "../comps/alertModal";
import Button from '@material-ui/core/Button';
import { withRouter } from "react-router";
import { withStyles } from '@material-ui/core/styles';
import Toast from "../comps/alertMessage";
import * as utils from "../../Utilities";
import downloadIcon from '../images/Download.png'
import {isMobile} from 'react-device-detect';
import reportIcon from '../images/report.png'

const drawerWidth = 240;

export const miniDirectory = 'mini';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
});


class MiniAssessmentsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coachUUID: localStorage.getItem("Id"),
      openAlertModal: false,
    };
  }

  miniAssessmentInfoTile = (record)=>{
    return(<>{record.name} {record.surname}<br/>{record.email}</>)
  }

  massageData = (data) => {
    for (let record of data) {
      record.uuid = record.uniqueId;
      record.startedAt = record.createdAt;
      record.language = utils.capitalize(record.localLanguage??'english');
      record.infoTile = <>{record.name} {record.surname}<br/>{record.email}</>
      record.infoTileSearchableText = [record.name, record.surname, record.email].join(' ');
      record.reportLink = record.section2CompletedAt?'Report':'-';
      aserver.convertUTCToLocal(record, 'startedAt');
      aserver.convertUTCToLocal(record, 'section2CompletedAt');
      record.reportLink = 
        <span 
          className="showHTMLReport" 
          onClick={(event) => {
            event.stopPropagation(); 
            this.showHTMLReport(record.uniqueId);
          }}
        >
          Report
        </span>

      if (!record.ennea)
        record.reportLink = '';

      if (isMobile) {
        let r = [];
        r.push(record.ennea);
        r.push(record.trifix);
        record.results = r.join(' ');

        const date = record.section2CompletedAt.slice(0, 10);
        record.guestCompletedAtDisplay = (
          <div className="completeMobileColumn">
              <img 
                src={reportIcon} 
                onClick={(event) => {
                  event.stopPropagation(); 
                  this.showHTMLReport(record.uniqueId);
                }} 
                className="showHTMLReports" 
                alt="icon" 
              />
            <span>{date}</span>
          </div>
        );
      } else {
        record.guestCompletedAtDisplay = record.section2CompletedAt; 
      }

      record.miniAssessmentInfoTile = this.miniAssessmentInfoTile(record)

    }
  }

  openAlertModal = (title, message) => {
    this.closeModal()
    this.setState({
      alertModalTitle: title,
      alertMessage: message,
      openAlertModal: true,
    })
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.closeModal()
    }
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      openAlertModal: false,
      confirmationModal: false,
      openModal: false,
      showModalCancelButton: false,
      requestModal: false,
      showResponseModal:false,
      openBackdrop:false,
      addMembersModal:false
    });
  }

  downloadSummary = async () => {
    try {
      let downloadSummary = await aserver.download(`api/v2/coaches/${this.state.coachUUID}/miniAssessmentsSpreadsheet`)
      if (downloadSummary.status === 200) {
        this.toastMessage("Downloading...", "success")
      } else {
        this.openAlertModal("Failed", "Failed")
      }
    } catch (err) {
      this.openAlertModal("Failed", "Failed")
    }
  }

  showHTMLReport = (uuid) => {
    window.open(`/coachportal/reports/${uuid}`, '_blank')
  }

  selectedData = (data) => {
    this.setState({
      selected: data
    })
  }

  copyLink = async (link) => {
    await navigator.clipboard.writeText(link)
    this.toastMessage("Copied to clipboard", "success")
  }

  toastMessage = (text, level) => {
    this.setState({
      message: text,
      level: level,
    })
    this.showToast()
  }

  showToast = () => {
    this.setState(
      {
        showToast: true
      },
      () => {
        setTimeout(() => this.setState({ showToast: false }), 2500);
      }
    );
  }


  render() {
    let assessmentLink = window.location.origin + (`/coachportal/${miniDirectory}/${this.state.coachUUID}`);
    let showAllColumnsDesktop = [
      { dataField: "infoTile", caption: "Info" },
      { dataField: "language", caption: "Language" },
      { dataField: "ennea", caption: "Ennea" },
      { dataField: "trifix", caption: "Trifix" },
      { dataField: "reportLink", caption: "Report" },
      { dataField: "startedAt", caption: "Started" },
      { dataField: "guestCompletedAtDisplay", caption: "Completed" }
    ];
  
    let showAllColumnsMobile = [
      { dataField: "miniAssessmentInfoTile", caption: "Info" },
      { dataField: "results", caption: "Ennea Results" },
      { dataField: "guestCompletedAtDisplay", caption: "Completed" }
    ];
    return (
      <main className="app-content">

        <h2 style={{ marginLeft: "4px", marginBottom:"1vh" }}>Mini-Assessment Self Registration Link</h2>
        <h4 style={{ margin: " 0 0 0 4px" }}>Give the link below to anyone and they'll be able to register for and do the mini-assessment. Their assessment results will appear automatically in the table below.</h4>
        <p style={{marginLeft: "4px"}}><a href={assessmentLink} target="_blank" rel="noreferrer">{assessmentLink}</a></p>
        <Button variant="contained" color="primary" type="submit" style={{ width: "10rem" }} onClick={() => this.copyLink(assessmentLink)}>Copy Link</Button>

        <h2 style={{ marginLeft: "4px", marginBottom: "1vh" }}>Mini-Assessments</h2>
        <AephoriaTable
          key={'miniAssessmentTable'}
          route={`api/v2/coaches/${this.state.coachUUID}/miniAssessments`}
          massageData={this.massageData}
          selectedData={this.selectedData}
          filterButtons={[]}
          tableFunctions={[
            { caption: 'Download spreadsheet', icon: downloadIcon,frequentlyUsed: true, minRecordsRequired: 0, ourownonclick: this.downloadSummary },
          ]}
          tableName="MiniAssessment"
          displayFields={[
              ...(isMobile ? showAllColumnsMobile : showAllColumnsDesktop)
            ]}
        />

        <AlertModal
          message={this.state.alertMessage}
          modalTitle={this.state.alertModalTitle}
          isOpen={this.state.openAlertModal}
          showClose={() => this.closeModal()}
        />

        <Toast
          level={this.state.level}
          message={this.state.message}
          visible={this.state.showToast}
        />
      </main>
    );
  }
}

export const MiniAssessments = withRouter(withStyles(styles)(MiniAssessmentsComponent));

